export type AudioInput = { deviceId: string; label: string };

/** Read previously exposed inputs without opening a microphone or prompting. */
export async function listKnownAudioInputs(
  media: Pick<MediaDevices, 'enumerateDevices'> = navigator.mediaDevices,
): Promise<AudioInput[]> {
  return (await media.enumerateDevices())
    .filter((device) => device.kind === 'audioinput' && device.deviceId && device.label)
    .map(({ deviceId, label }) => ({ deviceId, label }));
}

/** Ask on a click; release the permission probe without reading or saving audio. */
export async function listAudioInputs(
  media: Pick<MediaDevices, 'getUserMedia' | 'enumerateDevices'> = navigator.mediaDevices,
): Promise<AudioInput[]> {
  const permission = await media.getUserMedia({ audio: true });
  for (const track of permission.getTracks()) track.stop();
  return listKnownAudioInputs(media);
}
